import { Component, OnInit } from '@angular/core';
import {CompanyInfo} from "../shared/services/company-info/definitions/company-info.interface";
import {CompanyInfoService} from "../shared/services/company-info/company-info.service";

@Component({
  selector: 'app-online-task-inspection',
  templateUrl: './online-task-inspection.component.html',
  styleUrls: ['./online-task-inspection.component.scss'],
})
export class OnlineTaskInspectionComponent implements OnInit {
  public companyInfo: CompanyInfo;

  constructor(private companyInfoService: CompanyInfoService) {}

  ngOnInit(): void {
    this.companyInfo = this.companyInfoService.getCompanyInfo();
  }
}
